<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>資產交還管理</h1>
    </div>
    <div class="col">
      <div class="button_wrap main_button_wrap d-flex">
        <router-link to="/return_asset_new">
          <button class="add_btn">新增交還</button>
        </router-link>
      </div>
    </div>
    <div class="container-fluid datagrid_section">
      <div class="content">
        <div class="row mx-0">
          <!-- 單號 -->
          <div class="col">
            <p>單號</p>
            <input type="text" v-model="dgSearchParams.RR_ID" />
          </div>
          <!-- 交還狀態 -->
          <div class="col">
            <p>交還狀態</p>
            <select class="form-select" v-model="dgSearchParams.ReturnStatus">
              <option value="">--請選擇--</option>
              <option v-for="option in DropdownArray.ReturnStatus" :value="option">{{ option }}</option>
            </select>
          </div>
          <!-- 交還原因 -->
          <div class="col">
            <p>交還原因</p>
            <select class="form-select" v-model="dgSearchParams.Reason">
              <option value="">--請選擇--</option>
              <option v-for="option in DropdownArray.Reason" :value="option">{{ option }}</option>
            </select>
          </div>
          <!-- 交還人員 -->
          <div class="col">
            <p>交還人員</p>
            <select class="form-select" v-model="dgSearchParams.Custodian">
              <option value="">--請選擇--</option>
              <option v-for="item in DropdownArray.Staff" :key="item.Value" :value="item.Value">{{ item.Text }}</option>
            </select>
          </div>
          <!-- 接收人員 -->
          <div class="col">
            <p>接收人員</p>
            <select class="form-select" v-model="dgSearchParams.ReturnPerson">
              <option value="">--請選擇--</option>
              <option v-for="item in DropdownArray.Staff" :key="item.Value" :value="item.Value">{{ item.Text }}</option>
            </select>
          </div>
          <!-- 交還日期(起) -->
          <div class="col">
            <p>交還日期(起)</p>
            <div class="date-selector">
              <div class="input-container">
                <input type="date" v-model="dgSearchParams.StartDate" class="date-input" />
              </div>
            </div>
          </div>
          <!-- 交還日期(迄) -->
          <div class="col">
            <p>交還日期(迄)</p>
            <div class="date-selector">
              <div class="input-container">
                <input type="date" v-model="dgSearchParams.EndDate" class="date-input" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col justify-content-center d-flex">
      <div class="button_wrap d-flex">
        <button class="search_btn" @click="submit('', 'search')">檢索</button>
        <button class="empty_btn" @click="clear">清空</button>
        <!-- <button class="export_btn">匯出</button> -->
      </div>
    </div>
    <div class="dg-height mb-5">
      <DataTable lazy :key="dg.key" :first="dg.first" :size="'small'" :loading="dg.loading" :value="dgRowData"
        :sort-field="dg.sortField" :sort-order="dg.sortOrder" resizableColumns columnResizeMode="expand" showGridlines
        scrollable scrollHeight="420px" @page="submit($event, 'page')" @sort="submit($event, 'sort')" paginator
        :rows="dg.rows" :totalRecords="dg.totalRecords"
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        :rowsPerPageOptions="[10, 20, 30]"
        currentPageReportTemplate=" 第{currentPage}頁 ，共{totalPages}頁 總筆數 {totalRecords}">
        <Column>
          <template #body="slotProps">
            <return_asset_btn :params="slotProps"/>
          </template>
        </Column>
        <Column v-for="item in datagridField" :field="item.field" :header="item.header" sortable
          :style="{ 'min-width': item.width }"></Column>
        <Column style="min-width: 60px;">
          <template #body="slotProps">
            <Delete :params="slotProps" />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
<script setup>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import return_asset_btn from '@/components/return_asset_page/return_asset_btn.vue';
import { ReturnAsset_StatusArray, ReturnAsset_ReasonArray } from '@/assets/js/dropdown';
import Delete from "@/components/return_asset_page/return_asset_delete_btn.vue";
import Navbar from "@/components/Navbar.vue";
import {
  onActivated,
  onMounted,
  onUnmounted,
  reactive,
} from "vue";
import {
  useUtilsStore,
  useAPIStore
} from '@/store'
import {
  storeToRefs
} from 'pinia';
const utilsStore = useUtilsStore();
const apiStore = useAPIStore();
const {
  dgSearchParams,
  dg,
  dgRowData
} = storeToRefs(utilsStore);
const DropdownArray = reactive({
  ReturnStatus: ReturnAsset_StatusArray,
  Reason: ReturnAsset_ReasonArray,
  Staff: [],
})
const searchParams = reactive({
  RR_ID: '',
  ReturnStatus: '',
  Reason: '',
  Custodian: '',
  ReturnPerson: '',
  StartDate: '',
  EndDate: '',
});
const datagridField = [
  { header: "單號", field: "RR_ID", width: '150px'},
  { header: "交還狀態", field: "ReturnStatus", width: '100px' },
  { header: "交還原因", field: "Reason", width: '100px' },
  { header: "交還人員", field: "Custodian", width: '120px' },
  { header: "待交還數量", field: "UnreturnedNum", width: '120px' },
  { header: "已交還數量", field: "ReturnedNum", width: '120px' },
  { header: "交還日期", field: "ReturnDate", width: '150px' },
  { header: "接收人員", field: "ReturnPerson", width: '120px' },
]
onActivated(() => {
  submit('', ''); // 透過keep-alive 觸發的情況下，不更改條件刷新datagrid
})
onMounted(async () => {
  
  for (const key in searchParams) {
    dgSearchParams.value[key] = '';
  }
  submit('', 'search');
  DropdownArray.Staff = await apiStore.getUserNickName();
});
onUnmounted(() => {
  
})
async function submit(event, type) {
  const form = new FormData();
  utilsStore.setFormData(dgSearchParams.value, form)
  utilsStore.UpdatePageParameter(dg.value, event, type, form);
  const resultList = await apiStore.getMngDatagrid('/ReturnAssetMng/ReturnGrid', dg.value, form);
  dgRowData.value = resultList.rows;
  dg.value.totalRecords = resultList.total;
  dg.value.key++;
}
const clear = () => {
  utilsStore.clearSearchParams(dgSearchParams.value);
  submit('', 'search');
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.datagrid_section {
  .row {
    @include datagrid_bg;
  }

  input,
  select {
    @include dropdown_btn;
    width: 100%;
    height: 35px;
  }

  .content {
    p {
      @include datagrid_title;
    }
  }
}

.button_wrap {
  margin-bottom: 25px;
  gap: 20px;

}

.add_btn {
  @include datagrid_button_no1;

  &:hover {
    background-color: #537ebc;
  }
}

.return_btn {
  @include datagrid_button_no2;

  &:hover {
    background-color: #26426a;
  }
}

.search_btn {
  @include search_and_send_btn;

  &:hover {
    background-color: #5e7aa2;
  }
}

.empty_btn {
  @include empty_btn;

  &:hover {
    background-color: #5d85bd;
  }
}

@media only screen and (min-width: 1200px) {
  .main_section {
    padding: 0 10%;

    .datagrid_section {
      .row {
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 20px 5px;
        padding: 2% 5%;
      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {
    padding: 5%;

    .datagrid_section {
      .row {
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px 5px;
        padding: 5%;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .main_section {
    padding: 5%;

    .datagrid_section {
      .row {
        display: flex;
        flex-direction: column;
        gap: 10px 0;
        padding: 30px;

        p {
          font-size: 18px;
        }
      }
    }
  }
}
</style>